// Tiny country name → ISO-2 code → flag-emoji map.
// We can't enumerate every country, but the ones the user can pick in the
// Profile bio dropdown cover the realistic short-term userbase (West Africa
// focus + global English-speaking markets).
const NAME_TO_CC = {
  Nigeria: 'NG',
  Ghana: 'GH',
  Kenya: 'KE',
  'South Africa': 'ZA',
  Egypt: 'EG',
  Morocco: 'MA',
  Ethiopia: 'ET',
  Uganda: 'UG',
  Tanzania: 'TZ',
  Rwanda: 'RW',
  'United States': 'US',
  USA: 'US',
  'United Kingdom': 'GB',
  UK: 'GB',
  Canada: 'CA',
  Australia: 'AU',
  Germany: 'DE',
  France: 'FR',
  Spain: 'ES',
  Italy: 'IT',
  Netherlands: 'NL',
  India: 'IN',
  Brazil: 'BR',
  Mexico: 'MX',
  Argentina: 'AR',
  Japan: 'JP',
  China: 'CN',
  'South Korea': 'KR',
  Singapore: 'SG',
  UAE: 'AE',
  'United Arab Emirates': 'AE',
  'Saudi Arabia': 'SA',
  Turkey: 'TR',
  Portugal: 'PT',
  Ireland: 'IE',
  Sweden: 'SE',
  Norway: 'NO',
  Denmark: 'DK',
  Finland: 'FI',
  Switzerland: 'CH',
  Belgium: 'BE',
  Austria: 'AT',
  Poland: 'PL',
};

export function countryToISO2(name) {
  if (!name) return null;
  return NAME_TO_CC[name.trim()] || null;
}

/**
 * Converts an ISO-2 country code OR a country name to a flag emoji using
 * regional-indicator Unicode characters. Returns empty string for unknown
 * inputs (so we never render a broken tofu).
 */
export function countryFlagEmoji(countryNameOrCode) {
  if (!countryNameOrCode) return '';
  const cc = countryNameOrCode.length === 2
    ? countryNameOrCode.toUpperCase()
    : countryToISO2(countryNameOrCode);
  if (!cc || cc.length !== 2) return '';
  const base = 0x1F1E6 - 'A'.charCodeAt(0);
  return String.fromCodePoint(base + cc.charCodeAt(0)) + String.fromCodePoint(base + cc.charCodeAt(1));
}

// Maps a country name to its ISO-4217 currency code + symbol — used by the
// new tiered pricing widget on Create Event.
export const COUNTRY_TO_CURRENCY = {
  Nigeria:        { code: 'NGN', symbol: '₦' },
  Ghana:          { code: 'GHS', symbol: '₵' },
  Kenya:          { code: 'KES', symbol: 'KSh' },
  'South Africa': { code: 'ZAR', symbol: 'R' },
  Egypt:          { code: 'EGP', symbol: 'E£' },
  'United States':{ code: 'USD', symbol: '$' },
  Canada:         { code: 'CAD', symbol: 'C$' },
  'United Kingdom':{ code: 'GBP', symbol: '£' },
  Germany:        { code: 'EUR', symbol: '€' },
  France:         { code: 'EUR', symbol: '€' },
  Spain:          { code: 'EUR', symbol: '€' },
  Italy:          { code: 'EUR', symbol: '€' },
  Netherlands:    { code: 'EUR', symbol: '€' },
  Portugal:       { code: 'EUR', symbol: '€' },
  Ireland:        { code: 'EUR', symbol: '€' },
  Austria:        { code: 'EUR', symbol: '€' },
  Belgium:        { code: 'EUR', symbol: '€' },
  Australia:      { code: 'AUD', symbol: 'A$' },
  Japan:          { code: 'JPY', symbol: '¥' },
  India:          { code: 'INR', symbol: '₹' },
  Brazil:         { code: 'BRL', symbol: 'R$' },
};

export function getUserCurrency(countryName) {
  return COUNTRY_TO_CURRENCY[countryName] || { code: 'USD', symbol: '$' };
}
